import type { DropdownOption } from "../../types/api.types.js";

export type CmtsSelectOption = Readonly<{ value: string; label: string }>;

export function mapRcaDropdownOptions(options?: readonly DropdownOption[]): readonly CmtsSelectOption[] {
  if (!Array.isArray(options)) return [];
  return options
    .filter((option) => option.isActive !== false && typeof option.value === "string" && option.value.trim().length > 0)
    .map((option) => ({ value: option.value.trim(), label: option.label.trim() || option.code?.trim() || option.value.trim() }));
}
